module.exports = __webpack_public_path__ + "static/media/1603724.dade8720.jpg";